import '../../plugin/form-handler.jquery.js';

import './newsletter-form.jquery.scss';

$(document).ready(function() {
  var $newsletter = $('.newsletter');
  var $newsletterSuccess = $('.newsletter__success', $newsletter);
  var $newsletterEmail = $('#newsletter-email');

  $newsletterEmail.on('focus', function (e) {
    $.getScript('https://www.google.com/recaptcha/api.js');
  });

  $newsletter
    .formHandler({
      ajaxOptions: {
        success: function(data) {
          $(document).trigger("newsletter:success");
          $('span', $newsletterSuccess).text(data.message.title);
          $('p', $newsletterSuccess).text(data.message.text);
          $newsletter.addClass('newsletter--success');
        }
      }
    });
});
